<template>
  <div class="payment-create main-content">
    <form action="" @submit.prevent="submitPrePaymentData">
      <div class="page-header">
        <h3 class="page-title">{{ $t('prepayments.invoice_prepayment_processing') }}</h3>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link slot="item-title" to="/funder/dashboard">{{ $t('general.home') }}</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link slot="item-title" to="/funder/invoices">{{ $tc('invoices.invoice', 2) }}</router-link>
          </li>

          <li class="breadcrumb-item">{{  $t('prepayments.invoice_prepayment_processing') }}</li>
        </ol>
      </div>
      <SingleInvoiceRow :fetchData="fetchData" />
      <div class="page-header">
        <h3 class="page-title">{{ $t('prepayments.invoice_prepayment_processing') }}</h3>
        <div class="page-actions header-button-container mr-4">
          <base-button
            :loading="isLoading"
            :disabled="isLoading"
            icon="save"
            color="theme"
            type="submit"
            >
            {{ $t('prepayments.save_prepayment_processing') }}
          </base-button>
        </div>
      </div>

      <div class="payment-card card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">{{ $t('prepayments.invoice_prepayment_processing') }}</label>
                <base-text-area
                  v-model="formData.processing"
                  @input="$v.formData.processing.$touch()"
                />
                <div v-if="$v.formData.processing.$error">
                  <span v-if="!$v.formData.processing.required" class="text-danger">{{ $t('validation.required') }}</span>
                </div> 
              </div>
            </div>
          </div>
        </div>
      </div>
    <Attachment/>
  </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MultiSelect from 'vue-multiselect'
import { validationMixin } from 'vuelidate'
import moment from 'moment'
const { required, between, maxLength, numeric } = require('vuelidate/lib/validators')
import SingleInvoiceRow from '../invoices/SingleInvoiceRow'
import Attachment from './Attachment'
export default {
  components: { MultiSelect ,SingleInvoiceRow, Attachment},
  mixins: [validationMixin],
  data () {
    return {
      userType:null,
      fetchData:[],
      isLoading: false,
      formData:{
        processing:null,
      }
    }
  },
  created(){
    this.loadInvoice() 
  },
  validations () {
    return {
      formData:{
        processing:{
          required
        },
      }
    }
  },
  computed: {
  },
  watch: {
  },
  async mounted () {
    this.$nextTick(() => {
       this.loadData();
    })
  },
  methods: {
    ...mapActions('invoice', [
      'fetchInvoice',
      'SingleInvoiceArray',
      'fetchInvoiceShow'
    ]),
    ...mapActions('prepayment', [
      'fetchCreatePayment',
      'addPayment',
      'updatePayment',
      'fetchEditPaymentData',
      'updatePrepaymentRequest',
      'editPrepaymentRequest'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
     ...mapActions('LoanRequest', [
      'loanRequestStatus',
    ]),
    async loadInvoice () {
      let response = await this.SingleInvoiceArray(this.$route.params.id)
      if (response.data) {
        this.fetchData =response.data.invoice;
      }
    },
    async submitPrePaymentData () {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
          return true
      }
      let data = {
          id: this.$route.params.id,
          processing:this.formData.processing,
      }
      let response = await this.updatePrepaymentRequest(data)
      if (response.data.success==true) {
          window.toastr['success'](this.$t('prepayments.save_prepayment_processing'))
          return true
      }
    },
    async loadData () {
      if (this.$route.params.id) {
        let response = await this.editPrepaymentRequest(this.$route.params.id)
        this.formData.processing=response.data.prepaymentRequest.processing
      }    
    }
  }  
}
</script>
<style scoped>
.table-component{
  min-height: 0px;
}
</style>
